import {
  createParentConnectRequestMockHandler,
  getParentConnectBookingSuggestionMockHandler,
  getParentConnectOverviewMockHandler,
  getParentConnectSlotsMockHandler,
} from '@/features/parent-connect-booking/api';

export const parentConnectBookingHandlers = [
  getParentConnectOverviewMockHandler,
  getParentConnectBookingSuggestionMockHandler,
  getParentConnectSlotsMockHandler,
  createParentConnectRequestMockHandler,
];
